module.exports = __webpack_public_path__ + "img/comment.2c25ce11.svg";